var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "./Icon";
import Text from "./Text";
import { ceil, times } from 'lodash';
import React from 'react';
import { flexbox, space, layout } from 'styled-system';
import { styled } from "../utils";
var StyledPartners = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  a {\n    display: flex;\n    padding: 0.5rem;\n\n    img {\n      width: auto;\n      height: 60px;\n    }\n  }\n\n  a:first-of-type {\n    padding-left: 0;\n  }\n\n  a:last-of-type {\n    padding-right: 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  a {\n    display: flex;\n    padding: 0.5rem;\n\n    img {\n      width: auto;\n      height: 60px;\n    }\n  }\n\n  a:first-of-type {\n    padding-left: 0;\n  }\n\n  a:last-of-type {\n    padding-right: 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"])), flexbox, space, layout);
var Rating = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 0.5rem;\n\n  svg {\n    width: 21px;\n    height: 20px;\n    margin: 0 4px;\n  }\n\n  p {\n    margin: 0 0 0 4px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 0.5rem;\n\n  svg {\n    width: 21px;\n    height: 20px;\n    margin: 0 4px;\n  }\n\n  p {\n    margin: 0 0 0 4px;\n  }\n"])));
var Partners = function (_a) {
    var _b = _a.partners, partners = _b === void 0 ? [] : _b, className = _a.className, props = __rest(_a, ["partners", "className"]);
    return (React.createElement(StyledPartners, __assign({ "data-component": "Partners", className: className }, props), partners.map(function (_a) {
        var img = _a.img, url = _a.url, rating = _a.rating, caption = _a.caption, wundwCaption = _a.wundwCaption;
        return (React.createElement("a", { key: img, href: url, target: "_blank", rel: "noreferrer" },
            React.createElement("div", null,
                wundwCaption && React.createElement(Text, { m: 0 }, wundwCaption),
                React.createElement("img", { src: img, alt: img })),
            rating && (React.createElement(Rating, null,
                React.createElement("div", null, times(ceil(rating), function (index) { return (React.createElement(Icon.RatingStar, { key: index })); })),
                caption && React.createElement(Text, null, caption)))));
    })));
};
export default Partners;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Partners.js.map